import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { filesData } from "../../../data/files";
import { AiOutlineFilePdf, AiOutlineFileWord } from "react-icons/ai";
import { FiSquare } from "react-icons/fi"; // Divorce Case icon

const FileDetails = () => {
  const { id } = useParams();
  const file = filesData.all.find((file) => file.id === parseInt(id));
  const [files, setFiles] = useState(filesData.all);

  const handleAddFile = (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      const newFileType = newFile.type.includes("image") ? "image" : "document";

      const newFileData = {
        id: files.length + 1,
        name: newFile.name,
        type: newFileType,
        url: URL.createObjectURL(newFile), // Blob URL for file preview
        status: "Draft",
        modified: "just now",
      };

      setFiles([...files, newFileData]);
    }
  };

  const handleFileClick = (file) => {
    window.open(file.url, "_blank");
  };

  if (!file) {
    return <div>File not found</div>;
  }

  return (
    <div className="p-4 bg-white rounded shadow-sm flex flex-col  " style={{ height: "100vh" }}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-2">
          <FiSquare className="text-pink-500 w-6 h-6" style={{ strokeWidth: 2 }} />
          <h2 className="text-xl font-semibold">{file.name}</h2>
        </div>
        <label
          htmlFor="file-upload"
          className="cursor-pointer bg-primary text-white px-4 py-2  rounded-md hover:bg-primary"
        >
          + New File
        </label>
        <input
          id="file-upload"
          type="file"
          className="hidden"
          onChange={handleAddFile}
        />
      </div>

      <div className="">
        <table className=" border-b-2 table-auto w-full text-left">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-2 font-normal">Name</th>
              <th className="px-4 py-2 font-normal">Status</th>
              <th className="px-4 py-2 font-normal">Date Modified</th>
            </tr>
          </thead>
          <tbody>
            {files.map((file) => (
              <tr
                key={file.id}
                className="hover:bg-gray-50 cursor-pointer"
                onClick={() => handleFileClick(file)}
              >
                <td className="px-4 py-2 flex items-center space-x-3">
                  {file.type === "image" ? (
                    <img
                      src={file.url}
                      alt={file.name}
                      className="w-8 h-8 rounded object-cover"
                    />
                  ) : file.name.endsWith(".pdf") ? (
                    <AiOutlineFilePdf className="text-red-500 w-6 h-6" />
                  ) : (
                    <AiOutlineFileWord className="text-blue-500 w-6 h-6" />
                  )}
                  <span>{file.name}</span>
                </td>
                <td className="px-4 py-2 text-sm">{file.status}</td>
                <td className="px-4 py-2 text-sm">{file.modified}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FileDetails;
